import { addDays, format, isSameDay } from 'date-fns';
import React from 'react';
import {
  SearchCardArea,
  TrackingDataProps,
} from '../../../../../../../common/AnalyticsContext/LinkTracking';
import { useAnalytics } from '../../../../../../../common/AnalyticsContext/useAnalytics';
import { SearchResultAppointmentSummary } from '../../../../../../types';
import { DateLink, Label, Meat, NextAvailableView } from './NextAvailable.styles';

const formatDate = (date: Date, today: Date, abbreviated?: boolean) => {
  if (isSameDay(date, today)) {
    return 'Today';
  }

  if (isSameDay(date, addDays(today, 1))) {
    return 'Tomorrow';
  }

  return abbreviated ? format(date, 'EEE d MMM,') : format(date, 'EEE d MMM,');
};

const formatTime = (time: string) => {
  const result = time.match(/(\d+):(\d+)/);

  if (result && result.length > 2) {
    const date = new Date(0, 0, 0, Number(result[1]), Number(result[2]));
    return format(date, 'h:mma');
  }

  return null;
};

interface Props extends TrackingDataProps {
  appointmentSummary: SearchResultAppointmentSummary | null;
  nextUrl?: string;
  moreUrl?: string;
  onMoreClick?: VoidFunction;
  opensLightbox?: boolean;
}

export interface PropsWithDate extends Props {
  currentDate: Date;
  simplistic?: boolean;
}

export const NextAvailable = ({
  appointmentSummary,
  currentDate,
  moreUrl = '#',
  nextUrl = moreUrl,
  trackingData: clickTracking,
}: PropsWithDate) => {
  const moreCount = appointmentSummary ? appointmentSummary.count - 1 : 0;

  const limitedAppointments = moreCount === 0;

  useAnalytics({
    resultsData: {
      limitedAppointmentsMsgShown: limitedAppointments ? true : undefined,
    },
  });

  if (appointmentSummary === null) return null;

  const nextDate = new Date(appointmentSummary.firstAppointment.date ?? '');

  const nextTime = appointmentSummary.firstAppointment.time;

  const formattedTime = formatTime(String(nextTime));

  const nextButtonTracking = {
    ...clickTracking,
    searchCardArea: SearchCardArea.NEXT_AVAILABLE,
  };

  return (
    <NextAvailableView>
      <Label>Next available:</Label>
      <Meat>
        <DateLink to={nextUrl} trackingData={nextButtonTracking}>
          {formatDate(nextDate, currentDate, true)}
          {formattedTime && ` ${formattedTime}`}
        </DateLink>
      </Meat>
    </NextAvailableView>
  );
};
